/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Connect_Failed_Unknown_ClientInputs */

const en_mcp_connect_failed_unknown_client = /** @type {(inputs: Mcp_Connect_Failed_Unknown_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We couldn’t find the app that started this request.`)
};

const es_mcp_connect_failed_unknown_client = /** @type {(inputs: Mcp_Connect_Failed_Unknown_ClientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No encontramos la app que inició esta solicitud.`)
};

/**
* | output |
* | --- |
* | "We couldn’t find the app that started this request." |
*
* @param {Mcp_Connect_Failed_Unknown_ClientInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_connect_failed_unknown_client = /** @type {((inputs?: Mcp_Connect_Failed_Unknown_ClientInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Connect_Failed_Unknown_ClientInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_connect_failed_unknown_client(inputs)
	return en_mcp_connect_failed_unknown_client(inputs)
});